import { Box, useTheme } from "@mui/material";
import React from "react";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import { appImages } from "../../assets";
import Help from "./Help";

const ClientSupport = () => {
  const { palette } = useTheme();

  return (
    <>
      <Box
        height={"100vh"}
        display={"flex"}
        flexDirection={"column"}
        position={"relative"}
        sx={{
          background: palette.gradient.background,
          backgroundImage: `url(${appImages.helpPageBgImg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />
        <Box
          flexGrow={10}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Help />
        </Box>

        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
          }}
        />
      </Box>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default ClientSupport;
